module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/home/travis/build/dav-bro/stugase-website/src/components/Layout.js"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/about","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","title":"StugA SE","icon":"src/static/images/SE_Logo.png"},
    }]
